import {
    LEAD_HELP_MAIL_ID,
    LEAD_HELP_MAIL_LINK,
    LEAD_HELP_PHONE_NUMBER,
} from '../../constants';
import HelpCallIcon from '../../assets/images/HelpCallIcon.svg';
import HelpMailIcon from '../../assets/images/HelpMailIcon.svg';
import { Button, Modal } from 'antd';
import NeedHelpIcon from '../../assets/images/NeedHelpIcon.svg';
import { useState } from 'react';

const NeedHelpModal = () => {
    const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
    const handleHelpModalCancel = () => {
        setIsHelpModalOpen(false);
    };
    const showHelpModal = () => {
        setIsHelpModalOpen(true);
    };
    return (
        <>
            <Button
                type="default"
                onClick={showHelpModal}
                className="flex items-center justify-center rounded-full py-4 px-3 bg-white shadow-lg mr-12 border-1 border-[#275BDD4D] border-opacity-30"
            >
                <img src={NeedHelpIcon} alt="NeedHelpIcon" />
                <p className="text-[#275BDD] font-semibold">Need Help?</p>
            </Button>
            <Modal
                centered
                title={
                    <p className="text-xl text-black font-semibold">
                        Facing any issue while using the platform?
                    </p>
                }
                closable={{
                    'aria-label': 'Custom Close Button',
                }}
                open={isHelpModalOpen}
                onCancel={handleHelpModalCancel}
                footer={null}
                className="rounded-xl"
            >
                <div className=" flex flex-col items-start justify-center text-lg w-full gap-y-4">
                    <p className="text-[#666666] font-normal">
                        Our support team is just a call or click away.
                    </p>
                    <div className="flex items-center justify-start w-full gap-x-6">
                        <div className="flex gap-x-2 items-center justify-center">
                            <img src={HelpCallIcon} alt="HelpCallIcon" />
                            <p className="text-[#275BDD] font-semibold text-lg">
                                {LEAD_HELP_PHONE_NUMBER}
                            </p>
                        </div>
                        <div className="flex gap-x-2 items-center justify-center">
                            <img src={HelpMailIcon} alt="HelpMailIcon" />
                            <a
                                href={LEAD_HELP_MAIL_LINK}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <p className="text-[#275BDD] font-semibold  text-lg">
                                    {LEAD_HELP_MAIL_ID}
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default NeedHelpModal;
